import { View } from '@play-co/timestep-core/ui';
import * as config from './uiConfig';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import i18n from 'src/lib/i18n/i18n';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import sounds from 'src/lib/sounds';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { TextInput } from '../shared/TextInput';
import { NAME_LENGTH_CONSTRAINTS } from 'src/replicant/pet/pet.ruleset';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (name?: string) => void;

/**
 * Ask pet name dialog
 */
export default class PopupPetNameInput extends PopupBasic {
  private close: CloseHandler;
  private maxLength: LangBitmapFontTextView;
  private header: LangBitmapFontTextView;
  private body: LangBitmapFontTextView;
  private inputView: TextInput;
  private buttonOkay: ButtonScaleViewWithText;

  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      ...opts,
      ...config.nameInput.popup,
      height: 399,
      boxOpts: config.box,
      tracking: { feature: 'conversation', $subFeature: 'name-input' },
    });

    this.close = opts.close;

    this.bg.updateOpts(config.bg);
    this.buttonClose.removeFromSuperview();
    this.message.updateOpts(config.nameInput.message);

    this.header = new LangBitmapFontTextView({
      ...config.nameInput.header,
      superview: this.box,
      localeText: () => i18n('popupPetNameInput.header'),
    });

    // Delimiter line
    new View({
      ...config.nameInput.line,
      superview: this.box,
    });

    this.maxLength = new LangBitmapFontTextView({
      ...config.nameInput.maxLength,
      superview: this.box,
      localeText: () =>
        i18n('popupPetNameInput.maxLength', {
          maxLength: NAME_LENGTH_CONSTRAINTS[1],
        }),
    });

    this.inputView = new TextInput({
      tag: 'textinput',
      superview: this.box,
      ...config.nameInput.input,
    });

    this.body = new LangBitmapFontTextView({
      ...config.nameInput.body,
      superview: this.box,
      localeText: () => i18n('popupPetNameInput.body'),
    });

    this.buttonOkay = new ButtonScaleViewWithText({
      ...config.nameInput.button,
      superview: this.box,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        sounds.sfx.play('ok');
        return opts.close(this.inputView.text ?? this.inputView.placeholder);
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([]);
  }

  public init(opts: { name: string }) {
    super.init({
      message: i18n('popupPetNameInput.message'),
    });

    this.box.style.y -= 50;

    this.inputView.text = opts.name;

    this.inputView.updateOpts({
      minLength: NAME_LENGTH_CONSTRAINTS[0],
      maxLength: NAME_LENGTH_CONSTRAINTS[1],
    });

    this.inputView.on('InputValidated', (valid: boolean) => {
      this.buttonOkay.setDisabled(!valid);
    });
  }
}
